import { HomeIcon } from "@heroicons/react/outline";
import { Breadcrumb } from "@ui/types";
import classNames from "classnames";
import Link from "next/link";

interface BreadcrumbsProps {
  breadcrumbs: Breadcrumb[];
  hideHome?: boolean;
  onNavigate?: (href: string) => void;
}

export function Breadcrumbs(props: BreadcrumbsProps) {
  const handleClick = (e: React.MouseEvent, href: string) => {
    if (props.onNavigate) {
      e.preventDefault();
      props.onNavigate(href);
    }
  };

  return (
    <nav className="flex" aria-label="Breadcrumb">
      <ol className="flex items-center space-x-2">
        {!props.hideHome ? (
          <li>
            <div>
              <Link href="/messages" className="text-foreground/50">
                <HomeIcon className="flex-shrink-0 w-5 h-5" aria-hidden="true" />
                <span className="sr-only">Inbox</span>
              </Link>
            </div>
          </li>
        ) : null}
        {props.breadcrumbs.map((page, idx) => (
          <li key={page.href}>
            <div className="flex items-center">
              {props.hideHome && idx === 0 ? null : (
                <svg
                  className="text-foreground/50 flex-shrink-0 w-3 h-4"
                  xmlns="http://www.w3.org/2000/svg"
                  fill="currentColor"
                  viewBox="0 0 20 20"
                  aria-hidden="true"
                >
                  <path d="M5.555 17.776l8-16 .894.448-8 16-.894-.448z" />
                </svg>
              )}
              <Link
                href={page.href}
                onClick={(e) => handleClick(e, page.href)}
                className={classNames(
                  props.hideHome && idx === 0 ? "ml-0" : "ml-2",
                  page.current ? "text-foreground/80" : "text-foreground/50",
                  "text-sm font-medium",
                )}
                aria-current={page.current ? "page" : undefined}
              >
                {page.name}
              </Link>
            </div>
          </li>
        ))}
      </ol>
    </nav>
  );
}
